module.exports = __webpack_public_path__ + "img/medal_vip5.0454300.png";